// extracted by mini-css-extract-plugin
module.exports = {"Technologies":"Technologies_Technologies__1mSKP","Technologies__Title":"Technologies_Technologies__Title__jyQs-"};